const layout_data = []
const style_data = []

const layout_index = 0
const style_index = 0



export default layout_data;
export { style_data , layout_index , style_index };